import type { ParentComponent } from "solid-js";
import { ButtonStyled } from "./Button.styled";
import type { ButtonProps } from "./index";

export const Button: ParentComponent<ButtonProps> = (props) => (
    <ButtonStyled {...props}>
        {props.children}
    </ButtonStyled>
);
